import {
  GET_LEADER_SUCCESS,
  GET_DEPARTMENTS_REQUESTED,
  GET_DEPARTMENTS_SUCCESS,
  CLEAR_ERROR_SUCCESS,
  OPEN_MODAL_SUCCESS,
  REQUEST_PUT_SUCCESS,
  GET_CASHBOX_REQUESTED,
  GET_CASHBOX_SUCCESS,
  GET_CASHBOX_FAILED,
  ADD_CASHBOX_REQUESTED,
  ADD_CASHBOX_SUCCESS,
  ADD_CASHBOX_FAILED,
  GET_EMPLOYEES_REQUESTED,
  GET_DEPARTMENTLEADER_REQUESTED,
  GET_DEPARTMENTLEADER_SUCCESS,
  GET_DEPARTMENTLEADER_FAILED,
  GET_CHIEFACCOUNTANT_REQUESTED,
  GET_CHIEFACCOUNTANT_SUCCESS,
  GET_CHIEFACCOUNTANT_FAILED,
  GET_ACCOUNTANT_REQUESTED,
  GET_ACCOUNTANT_SUCCESS,
  GET_ACCOUNTANT_FAILED,
  GET_SENIORCOMMODITYEXPERT_REQUESTED,
  GET_SENIORCOMMODITYEXPERT_SUCCESS,
  GET_SENIORCOMMODITYEXPERT_FAILED,
  GET_GOODSSPECIALIST_REQUESTED,
  GET_GOODSSPECIALIST_SUCCESS,
  GET_GOODSSPECIALIST_FAILED,
  GET_EMPLOYEE_REQUESTED,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAILED,
  GET_REASONS_REQUESTED,
  GET_REASONS_SUCCESS,
  GET_REASONS_FAILED,
  HANDBOOK_RESET,
  CASHBOX_RESET,
  ADD_BRANCH_REQUESTED,
  ADD_BRANCH_SUCCESS,
  GET_BRANCHES_REQUESTED,
  GET_BRANCHES_SUCCESS,
  CHANGE_BRANCH_REQUESTED,
  CHANGE_BRANCH_SUCCESS,
  DELETE_BRANCH_REQUESTED,
  DELETE_BRANCH_SUCCESS,
  BRANCH_FAILED,
  PAGE_BRANCH_FAILED,
  GET_LEADER_REQUESTED,
  CHANGE_AD_IMAGE_REQUESTED,
  CHANGE_AD_IMAGE_SUCCESS,
  GET_AD_IMAGE_REQUESTED,
  GET_AD_IMAGE_SUCCESS,
  AD_IMAGE_FAILED,
  DELETE_AD_IMAGE_REQUESTED,
  DELETE_AD_IMAGE_SUCCESS,
  GET_DEPARTMENTS_TAB,
  GET_DEPARTMENTS_TAB_SUCCESS, RESET_ALL_OPTIONS, RESET_HANDBOOK_ERROR,

} from './actionTypes'

export const resetAllOptions = () => ({
  type: RESET_ALL_OPTIONS
})

export const getDepartmentTabSuccess = payload => ({
  type: GET_DEPARTMENTS_TAB_SUCCESS,
  payload
})

export const getDepartmentsTab = payload => ({
  type: GET_DEPARTMENTS_TAB,
  payload
})

export const getLeader = name => ({
  type: GET_LEADER_REQUESTED,
  payload: {
    filters: {
      active: true,
      role: "BRANCH_DIRECTOR",
      name
    }
  }
})

export const getLeaderSuccess = payload => ({
  type: GET_LEADER_SUCCESS,
  payload,
})

export const getDepartments = (bySearch, access = false, isMain) => ({
  type: GET_DEPARTMENTS_REQUESTED,
  payload: {
    bySearch,
    access,
    isMain
  },
})

export const getDepartmentsSuccess = payload => ({
  type: GET_DEPARTMENTS_SUCCESS,
  payload,
})

export const clearError = () => ({ type: CLEAR_ERROR_SUCCESS })

export const openModal = () => ({ type: OPEN_MODAL_SUCCESS })

export const requestPut = () => ({ type: REQUEST_PUT_SUCCESS })

export const pageFailed = payload => ({
  type: PAGE_BRANCH_FAILED,
  payload,
})

export const getCashbox = ({id, active, type}) => ({
  type: GET_CASHBOX_REQUESTED,
  payload: {id, active, type},
})

export const getCashboxSuccess = payload => ({
  type: GET_CASHBOX_SUCCESS,
  payload,
})

export const getCashboxFailed = payload => ({
  type: GET_CASHBOX_FAILED,
  payload,
})

export const resetHandbook = () => ({
  type: HANDBOOK_RESET
})

export const addCashbox = (data) => ({
  type: ADD_CASHBOX_REQUESTED,
  payload: data
})

export const addCashboxSuccess = (payload) => ({
  type: ADD_CASHBOX_SUCCESS,
  payload
})

export const addCashboxFailed = payload => ({
  type: ADD_CASHBOX_FAILED,
  payload
})

export const cashboxReset = () => ({
  type: CASHBOX_RESET
})

export const getEmployees = (payload) => ({
  type: GET_EMPLOYEES_REQUESTED,
  payload
})

export const getDepartmentLeader = (payload) => ({
  type: GET_DEPARTMENTLEADER_REQUESTED,
  payload
})

export const getDepartmentLeaderSuccess = (payload) => ({
  type: GET_DEPARTMENTLEADER_SUCCESS,
  payload
})

export const getDepartmentLeaderFailed = payload => ({
  type: GET_DEPARTMENTLEADER_FAILED,
  payload
})

export const getChiefAccountant = (payload) => ({
  type: GET_CHIEFACCOUNTANT_REQUESTED,
  payload
})

export const getChiefAccountantSuccess = (payload) => ({
  type: GET_CHIEFACCOUNTANT_SUCCESS,
  payload
})

export const getChiefAccountantFailed = payload => ({
  type: GET_CHIEFACCOUNTANT_FAILED,
  payload
})

export const getAccountant = (payload) => ({
  type: GET_ACCOUNTANT_REQUESTED,
  payload
})

export const getAccountantSuccess = (payload) => ({
  type: GET_ACCOUNTANT_SUCCESS,
  payload
})

export const getAccountantFailed = payload => ({
  type: GET_ACCOUNTANT_FAILED,
  payload
})

export const getSeniorCommodityExpert = (payload) => ({
  type: GET_SENIORCOMMODITYEXPERT_REQUESTED,
  payload
})

export const getSeniorCommodityExpertSuccess = (payload) => ({
  type: GET_SENIORCOMMODITYEXPERT_SUCCESS,
  payload
})

export const getSeniorCommodityExpertFailed = payload => ({
  type: GET_SENIORCOMMODITYEXPERT_FAILED,
  payload
})

export const getGoodsSpecialist = (payload) => ({
  type: GET_GOODSSPECIALIST_REQUESTED,
  payload
})

export const getGoodsSpecialistSuccess = (payload) => ({
  type: GET_GOODSSPECIALIST_SUCCESS,
  payload
})

export const getGoodsSpecialistFailed = payload => ({
  type: GET_GOODSSPECIALIST_FAILED,
  payload
})

export const getEmployee = (payload) => ({
  type: GET_EMPLOYEE_REQUESTED,
  payload
})

export const getEmployeeSuccess = (payload) => ({
  type: GET_EMPLOYEE_SUCCESS,
  payload
})

export const getEmployeeFailed = payload => ({
  type: GET_EMPLOYEE_FAILED,
  payload
})

export const getReasons = (payload) => ({
  type: GET_REASONS_REQUESTED,
  payload
})

export const getReasonsSuccess = (payload) => ({
  type: GET_REASONS_SUCCESS,
  payload
})

export const getReasonsFailed = payload => ({
  type: GET_REASONS_FAILED,
  payload
})

export const addBranch = (payload) => ({
  type: ADD_BRANCH_REQUESTED,
  payload
})

export const addBranchSuccess = (payload) => ({
  type: ADD_BRANCH_SUCCESS,
  payload
})

export const getBranches = (size, page) => ({
  type: GET_BRANCHES_REQUESTED,
  size,
  page
})

export const getBranchesSuccess = payload => ({
  type: GET_BRANCHES_SUCCESS,
  payload,
})

export const changeBranch = (payload) => ({
  type: CHANGE_BRANCH_REQUESTED,
  payload
})

export const changeBranchSuccess = payload => ({
  type: CHANGE_BRANCH_SUCCESS,
  payload,
})

export const deleteBranch = (id, size, page) => ({
  type: DELETE_BRANCH_REQUESTED,
  payload: { id, size, page }
})

export const deleteBranchSuccess = (payload) => ({
  type: DELETE_BRANCH_SUCCESS,
  payload
})

export const returnFailed = payload => ({
  type: BRANCH_FAILED,
  payload,
})

export const adImage = (name, branchId, advertImage) => ({
  type: CHANGE_AD_IMAGE_REQUESTED,
  payload: { name, branchId, advertImage }
})

export const adImageSuccess = (payload) => ({
  type: CHANGE_AD_IMAGE_SUCCESS,
  payload
})

export const getAdImage = (branchId) => ({
  type: GET_AD_IMAGE_REQUESTED,
  branchId
})

export const getAdImageSuccess = (payload) => ({
  type: GET_AD_IMAGE_SUCCESS,
  payload
})

export const returnFailedAdImage = payload => ({
  type: AD_IMAGE_FAILED,
  payload,
})
export const deleteAdImage = (branchId) => ({
  type: DELETE_AD_IMAGE_REQUESTED,
  branchId
})

export const deleteAdImageSuccess = () => ({
  type: DELETE_AD_IMAGE_SUCCESS,

})

export const resetHandbookError = () => ({
  type: RESET_HANDBOOK_ERROR,
})